import React, { useState, useCallback } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import ActiveOperations from '../common/ActiveOperations';
import { useSignalR } from '../../hooks/useSignalR';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { connected } = useSignalR();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = useCallback(() => {
    setSidebarOpen((prev) => !prev);
  }, []);

  const closeSidebar = useCallback(() => {
    setSidebarOpen(false);
  }, []);

  return (
    <div className="app-layout">
      {sidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar} />}
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      <div className="main-content">
        <Header onMenuToggle={toggleSidebar} signalRConnected={connected} />
        <main className="page-content">
          {children}
        </main>
      </div>
      <ActiveOperations />
    </div>
  );
};

export default Layout;
